@if((resetEmailCount > 1) && !limitReached) {
    <p-message
        *ngIf="emailSent$ | async"
        severity="success"
        text="Email sent successfully."
        data-auto-id="email-confirm-success"
        class="plain-message"
    ></p-message>
    <br>
}

@if (!limitReached) {
    <p-card data-auto-id="email-confirm-with-resend">
        <ng-template pTemplate="header">
            <div class="email-sent-visual p-4">
                <div class="bg-blue-100 w-full h-full flex justify-content-center align-items-center">
                    <img src="./assets/icons/email-sent.svg" alt="Email Sent" class="email-sent-icon">
                </div>
            </div>
        </ng-template>
        <ng-template pTemplate="title" > {{ title }} </ng-template>
        
        <div>
            <p class="extra-line-height" data-auto-id="email-confirm-message" [innerHTML]="message"></p>
            
            <p class="extra-line-height" *ngIf="isForPasswordReset" data-auto-id="email-confirm-registration">
                Didn't get the email? Please check your spam folder or 
                <a
                    (click)="gotoRegister()"
                    class="underline cursor-pointer white-space-nowrap text-blue-700"
                    data-auto-id="email-confirm-register-link"
                    tabindex="0"
                >register here</a>. You can also <a
                    (click)="gotoLogin()"
                    class="underline cursor-pointer white-space-nowrap text-blue-700"
                    data-auto-id="email-confirm-login-link"
                    tabindex="1"
                >log in</a>.
            </p>

            <p class="mt-5 mb-0" *ngIf="!isForPasswordReset" data-auto-id="email-confirm-to-close">Feel free to close this window.</p>

            @if (isForPasswordReset) {
                <p-button
                    variant="outlined"
                    severity="secondary" 
                    [rounded]="true"
                    class="w-full mt-3 flex align-items-center justify-content-center" 
                    data-auto-id="email-confirm-resend-email"
                    styleClass="w-full white-space-nowrap"
                    (click)="initiateReset()"
                    [ariaLabel]="'Resend Email Button'"
                    [disabled]="initiatingReset"
                >
                    @if (initiatingReset) {
                        <i class="pi pi-spin pi-spinner"></i>&nbsp;Resending Email
                    } @else {
                        Resend Email
                    }
                </p-button>
            }
        </div>
    </p-card>
} @else {
    <p-card data-auto-id="email-confirm-limit-reached">
        <ng-template pTemplate="header">
            <div class="email-sent-visual p-4">
                <div class="bg-blue-100 w-full h-full flex justify-content-center align-items-center">
                    <img src="./assets/svg/Hands_Give.svg" alt="Email Sent" class="email-sent-icon">
                </div>
            </div>
        </ng-template>
        <ng-template pTemplate="title"> You've reached the resend limit. </ng-template>
        <div>
            <p class="extra-line-height">
                Please wait 15 minutes before trying again.
            </p>
            <p class="m-0" *ngIf="isForPasswordReset">
                Still can't find your password email?
            </p>
            <ul class="mt-1 pl-4">
                <li> Double-check the email address you provided.</li>
                <li> Look in your spam or junk folders.</li>
                <li> Not sure which email you used? You can always create a new account with a different email.</li>
            </ul>
        </div>
    </p-card>
}